import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import "./App.css";
import CustomToast from "./components/CustomToast";
import "./i18n";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store";
import "./styles/fonts.css";
//
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
//
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
      <CustomToast />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
